export const UPDATE_CONTRIBUTION_DATA = 'UPDATE_CONTRIBUTION_DATA';
export const MODEL_CONTRIBUTION_DATA = 'MODEL_CONTRIBUTION_DATA';
export const SET_INITIAL_STATE_FOR_CONTRIBUTIONS = 'SET_INITIAL_STATE_FOR_CONTRIBUTIONS';

export const setInitialStateForContributions = (data: any) => ({
  type: SET_INITIAL_STATE_FOR_CONTRIBUTIONS,
  payload: data,
});

export const updateContributionData = (data: Array<Record<string, any>>) => ({
  type: UPDATE_CONTRIBUTION_DATA,
  payload: data,
});

export const modelContributionData = () => ({
  type: MODEL_CONTRIBUTION_DATA,
});
